// extracted by mini-css-extract-plugin
module.exports = {"grid":"incentive-grid_grid__1o8G_"};